import React from 'react';
import styles from './ServicePreview.module.css';
import Card from '../UI/Card';
import Button from '../UI/Button';
import { Link } from 'react-router-dom';

const ServicePreview = () => {
    const services = [
        {
        id: 1,
        icon: '💻',
        title: 'Web Development',
        description: 'Custom websites and web applications built with modern technologies and best practices.'
        },
        {
        id: 2,
        icon: '🎨',
        title: 'UI/UX Design',
        description: 'Beautiful and intuitive user interfaces that provide exceptional user experiences.'
        },
        {
        id: 3,
        icon: '📱',
        title: 'Mobile Apps',
        description: 'Native and cross-platform mobile applications for iOS and Android devices.'
        }
    ];

    return (
        <section className={styles.services}>
            <div className={styles.container}>
                <div className={styles.sectionHeader}>
                    <h2>Our Services</h2>
                    <p>We offer comprehensive digital solutions to help your business thrive in the digital age.</p>
                </div>
                <div className={styles.servicesGrid}>
                    {services.map((service) => (
                        <Card
                        key={service.id}
                        variant="elevated"
                        padding="large"
                        className={styles.serviceCard}
                        >
                            <div className={styles.serviceIcon}>{service.icon}</div>
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                        </Card>
                    ))}
                </div>
                <div className={styles.ctaWrapper}>
                    <Button
                        as={Link}
                        to="/services"
                        variant="primary"
                        size="large"
                        className={styles.ctaButton}
                        >
                        View All Services →
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default ServicePreview;